import { enGb as accountsPaymentsTranslations } from "modules/accounts-payments/translations/en-gb";
import * as applicationsTranslations from "modules/applications/translations";
import * as authTranslations from "modules/auth/translations";
import * as bankAccountsTranslations from "modules/bank-accounts/translations";
import { enGb as checkoutTranslations } from "modules/checkout/translations/en-gb";
import { circuitBreaker as circuitBreakerOldTranslations } from "modules/circuit-breaker/i18n/en-GB/circuitBreaker";
import { enGb as circuitBreakerTranslations } from "modules/circuit-breaker/translations/en-gb";
import { connectTranslations } from "modules/connect";
import { enGb as customerBanksTranslations } from "modules/customer-banks/translations/en-gb";
import { enGb as customerTranslations } from "modules/customers/translations/en-gb";
import { enGb as dashboardTranslations } from "modules/dashboard/translations/en-gb";
import { enGb as mandatesTranslations } from "modules/mandates/translations/en-gb";
import * as paymentsTranslations from "modules/payments/translations";
import { payoutsTranslations } from "modules/payouts";
import { refundsTranslations } from "modules/refunds";
import { enGb as stablecoinsTranslations } from "modules/stablecoins/translations/en-gb";
import * as userManagementTranslations from "modules/user-management/translations/en-gb";
import * as userSettingsTranslations from "modules/user-settings/translations";
import { enGb as voltAccountsTranslations } from "modules/volt-accounts/translations/en-gb";
import { enGb as workflowsTranslations } from "modules/workflows/translations/en-gb";

import { common } from "./common";
import { countries } from "./countries";
import { currencies } from "./currencies";
import { customers } from "./customers";
import { errors } from "./errors";
import { payments } from "./payments";

const index = {
  accountsPayments: accountsPaymentsTranslations,
  auth: authTranslations.enGb,
  applications: applicationsTranslations.enGb,
  bankAccounts: bankAccountsTranslations.enGb,
  customerBanks: customerBanksTranslations,
  circuitBreaker: Object.assign(
    circuitBreakerOldTranslations,
    circuitBreakerTranslations
  ),
  connect: connectTranslations.enGb,
  checkout: checkoutTranslations,
  common,
  countries,
  currencies,
  customers: Object.assign(customers, customerTranslations),
  dashboard: dashboardTranslations,
  errors,
  mandates: mandatesTranslations,
  payments: Object.assign(payments, paymentsTranslations.enGb),
  payouts: Object.assign(payoutsTranslations.enGb),
  refunds: refundsTranslations.enGb,
  stablecoins: stablecoinsTranslations,
  workflows: workflowsTranslations,
  users: userManagementTranslations.enGb,
  userSettings: userSettingsTranslations.enGb,
  voltAccounts: voltAccountsTranslations,
};

export default index;
